/* @flow */

import prop from 'lodash/property';
import { INFO_COLOR, DANGER_COLOR } from './utils/constants';
import swal from './swal';
import { toastError, toastSuccess } from './toasts';

const message = prop('response.data.message');

const alertas = {
    error: (text: string) => swal.fire('Ops...', text, 'error'),
    cadastroUsuarioRealizado: () => swal.fire(
        'Seu cadastro foi realizado!',
        'Continue para entrar.',
        'success',
    ),
    erroLinkCadastroUsuarioInvalido: () => swal.fire(
        'Link de cadastro inválido.',
        'Entre em contato para realizar o cadastro de usuário.',
        'error',
    ),
    erroCadastrarUsuario: (error: Error) => swal.fire(
        'Ops...',
        message(error) || 'Não foi possível o cadastrar usuário...',
        'error',
    ),
    erroLogin: (error: Error) => swal.fire(
        message(error) || 'Não foi possível entrar',
        '',
        'error',
    ),
    sucessoContratacao: (tokenTransacao: string) => swal.fire({
        title: 'Sucesso !',
        html: `
        Cadastro efetuado, agora estamos aguardando a aprovação do seu cartão!
        <br>
        Estamos felizes por ter você conosco, em breve entraremos em contato! 😍
        `,
        type: 'success',
        onClose: () => window.location.replace(`http://hml.app.plom.com.br/cadastro-usuario?tokenTransacao=${tokenTransacao}`),
    }),
    erroSetSessaoPagseguro: (error: Error) => swal.fire(
        'Ops...',
        message(error) || 'Não foi possível criar sessão.',
        'error',
    ),
    senhaAltaradaComSucesso: () => swal.fire(
        'Sua senha foi alterada com sucesso!',
        '',
        'success',
    ),
    erroAlterarSenha: (error: Error) => swal.fire(
        'Ops...',
        message(error) || 'Não foi possível alterar a senha.',
        'error',
    ),
    alertarFinalizacao: (title: string) => swal.fire({
        type: 'warning',
        title,
        timer: 1500,
        showConfirmButton: false,
    }),
    recuperarProduto: (nome: string) => swal.fire({
        title: `${nome} movido para lixeira.`,
        toast: true,
        type: 'info',
        showConfirmButton: true,
        confirmButtonColor: INFO_COLOR,
        confirmButtonText: 'Desfazer',
        position: 'bottom',
        timer: 4000,
    }),
    promocaoComPrecoMaior: () => swal.fire({
        title: 'A promoção não pode ser maior que o valor original do produto',
        type: 'error',
        timer: 5000,
    }),
    excluirIrreversivel: (title: string) => swal.fire({
        title,
        text: 'Esta ação é irreversível.',
        confirmButtonText: 'Excluir',
        confirmButtonColor: DANGER_COLOR,
        type: 'error',
        showCancelButton: true,
    }),
    erroAlterarEtapa: (error: Error) => swal.fire(
        'Ops...',
        message(error) || 'Não foi possível alterar a etapa.',
        'error',
    ),
    fimDoFuncionamentoAlterado: (horaFim: string) => swal.fire({
        title: `Fim do funcionamento alterado para ${horaFim}!`,
        toast: true,
        type: 'info',
        position: 'bottom',
        timer: 4000,
        showConfirmButton: false,
    }),
    inicioDoFuncionamentoAlterado: (horaInicio: string) => swal.fire({
        title: `Inicio do funcionamento alterado para ${horaInicio}!`,
        toast: true,
        type: 'info',
        position: 'bottom',
        timer: 4000,
        showConfirmButton: false,
    }),
    funcionamentoRemovido: () => swal.fire({
        title: 'Funcionamento removido!',
        toast: true,
        type: 'info',
        position: 'bottom',
        timer: 4000,
        showConfirmButton: false,
    }),
    informacoesDoFuncionamentoSalvas: () => swal.fire({
        title: 'Parabéns!',
        text: 'Informações de funcionamento salvas com sucesso!',
        toast: true,
        type: 'success',
        position: 'top-right',
        timer: 4000,
        showConfirmButton: false,
    }),
    precoComlementoAlteradoComSucesso: () => swal.fire({
        title: 'Preço alterado!',
        type: 'success',
        timer: 4000,
        position: 'bottom',
        toast: true,
        showConfirmButton: false,
    }),
    produtoRemovidoDoGrupoComplemento: () => swal.fire({
        title: 'Produto removido do grupo de complemento!',
        type: 'success',
        timer: 4000,
        position: 'bottom',
        toast: true,
        showConfirmButton: false,
    }),
    erroAdicionarProdutoAoGrupoComplemento: (error: Error) => swal.fire(
        message(error) || 'Não foi possível adicionar produtos ao grupo de complemento.',
        '',
        'error',
    ),
    confirmacaoCadastrarCategoria: (nome: string) => swal.fire({
        title: 'Cadastrar uma nova categoria?',
        html: 'Por padrão, as categorias cadastradas por aqui serão exibidas no final do cardapio, em todos os horários de funcionamento e sem impressora. Para modifica-las acesse sua lista de categorias.',
        showCancelButton: true,
        confirmButtonText: 'Cadastrar',
        input: 'text',
        inputAutoTrim: true,
        inputValue: nome,
        type: 'question',
    }),
    categoriaCadastradaComSucesso: (nome: string) => toastSuccess.fire(`Categoria ${nome} cadastrada.`),
    erroCadastrarCategoria: (error: Object = {}) => toastError.fire(message(error) || 'Categoria não foi cadastrada'),
};

export default alertas;
